import { jsPDF } from "jspdf";

export const download = (line, ticket, date, type, officeName, time) => {
	var doc = new jsPDF({
		unit: "px",
		format: [400, 400],
	});

	doc.setDrawColor(0);
	doc.setFillColor(20, 90, 180);
	doc.rect(0, 0, 400, 500, "F");
	doc.setFillColor(245, 245, 249);
	doc.rect(50, 50, 300, 320, "F");
	doc.setTextColor(245, 245, 240);

	doc.setTextColor(0, 0, 0);
	doc.setFont("helvetica", "normal");
	doc.setFontSize(14);
	doc.text(
		`${type === "ticket" ? "Numero de Ticket:" : "Numero de Reserva:"}`,
		200,
		80,
		null,
		null,
		"center"
	);
	doc.setFont("helvetica", "bold");
	doc.setTextColor(20, 90, 180);
	doc.setFontSize(43);
	doc.text(
		`${type === "ticket" ? ticket.prefix + ticket.number : ticket.code}`,
		200,
		140,
		null,
		null,
		"center"
	);
	doc.setFont("helvetica", "normal");
	doc.setFontSize(14);
	doc.setTextColor(0, 0, 0);
	doc.text("Nombre de la oficina:", 200, 180, null, null, "center");
	doc.setFont("helvetica", "bold");
	doc.setFontSize(16);
	doc.setTextColor(20, 90, 180);
	doc.text(`${officeName}`, 200, 200, null, null, "center");

	doc.setFont("helvetica", "normal");
	doc.setFontSize(14);
	doc.setTextColor(0, 0, 0);
	doc.text("Nombre de la fila:", 200, 240, null, null, "center");
	doc.setFont("helvetica", "bold");
	doc.setFontSize(16);
	doc.setTextColor(20, 90, 180);
	doc.text(
		`${type === "ticket" ? line.name : line.name}`,
		200,
		260,
		null,
		null,
		"center"
	);
	doc.setFont("helvetica", "normal");
	doc.setFontSize(14);
	doc.setTextColor(20, 90, 180);
	doc.text("En espera de atención", 200, 300, null, null, "center");
	doc.setFont("helvetica", "normal");
	doc.setFontSize(14);
	doc.setTextColor(0, 0, 0);
	doc.text("Fecha de emisión:", 200, 320, null, null, "center");
	doc.setFont("helvetica", "bold");
	doc.setFontSize(16);
	doc.setTextColor(20, 90, 180);
	doc.text(`${date}`, 200, 340, null, null, "center");
	type === "ticket"
		? ""
		: doc.text(`${time && time}`, 200, 360, null, null, "center");
	doc.save(
		`${
			type === "ticket"
				? "ticket-" + ticket.prefix + ticket.number
				: "Reserva-" + ticket.code
		}`
	);
};
